/**
 * 商品销售报表（数据分析）
 * 接口约定（需后端实现）：
 * - 分页：POST /cabinet/admin/oms/AdminOmsProductSalesReportQueryController/page
 * - 导出：POST /cabinet/admin/oms/AdminOmsProductSalesReportQueryController/queryForExport
 * 查询参数：gmtCreateStart、gmtCreateEnd（发货单创建时间，必填）、shopCode（门店编号）、productCode（商品编号）
 * 供应商等角色数据隔离由后端按登录态处理
 */
import type { PageContext } from '@zto/zpage'
import { UI_PAGE_EVENTS } from '@zto/zpage-ui-element'
import { ElLoading } from 'element-plus'


function formatPercent(value: unknown): string {
  if (value === null || value === undefined || value === '') return '--'
  const n = Number(value)
  if (Number.isNaN(n)) return '--'
  return `${value}%`
}

function formatNumber(value: unknown): string {
  if (value === null || value === undefined || value === '') return '--'
  const n = Number(value)
  if (Number.isNaN(n)) return '--'
  return `${value}`
}

export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/cabinet/admin/oms/AdminOmsProductSalesReportController/getByProduct',
        responseTransform: (res: any) => {
          console.info('🚀 ~ file:index method:responseTransform line:36 ----- res', res)
          return !!res && Object.keys(res).length > 0 ? [res] : []
        }
      },
    },
    searchOn: [UI_PAGE_EVENTS.ACTIVATED],
    search: {
      items: [
        {
          label: '发货单创建时间',
          labelWidth: 100,
          type: 'date-range-picker',
          prop: 'gmtCreateStart',
          toProp: 'gmtCreateEnd',
          defaultTo: 'now',
          defaultRange: 30,
          maxRange: 365,
          span: 8
        },
        { type: 'input', prop: 'inShopCode', label: '门店编号', span: 6 },
        { type: 'input', prop: 'productCode', label: '商品编号', span: 6, required: true },
      ]
    },
    toolbar: {
      noExport: true,
      items: []
    },
    table: {
      noOperation: true,
      columns: [
        { label: '商品名称', prop: 'productName', minWidth: 160 },
        { label: '商品编号', prop: 'productCode', minWidth: 180 },
        { label: '实发门店数', prop: 'shippedShopCount', minWidth: 110 },
        { label: '实发商品数', prop: 'shippedGoodsCount', minWidth: 110 },
        { label: '已入柜商品数', prop: 'inboundCount', minWidth: 120 },
        { label: '柜中商品数', prop: 'inCabinetCount', minWidth: 110 },
        { label: '成交商品数', prop: 'dealCount', minWidth: 110 },
        { label: '申请退款商品数', prop: 'refundApplyCount', minWidth: 130 },
        { label: '成交未退款数量', prop: 'dealNoRefundCount', minWidth: 130 },
        {
          label: '累计到货销售转化率',
          minWidth: 150,
          formatter: (row: any) => formatPercent(row.cumulativeInboundToSaleRate)
        },
        {
          label: '入柜商品平均滞销天数',
          minWidth: 160,
          formatter: (row: any) => formatNumber(row.avgStrandedDaysInCabinet)
        },
        { label: '滞销超72H商品数', prop: 'strandedOver72Count', minWidth: 140 },
        { label: '待入柜商品数', prop: 'pendingInboundCount', minWidth: 120 },
        { label: '异常出库商品数', prop: 'abnormalOutboundGoodsCount', minWidth: 140 }
      ]
    }
  }
}
